import DateRangePicker from "./daterangepicker"

window.DateRangePicker = DateRangePicker

export { DateRangePicker }
